import universal from 'react-universal-component';
import Loader from '@client/components/loader/Loader';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

export function episodeRoute(episodeSlug, seriesSlug) {
  return `${ROUTES.seriesById}${seriesSlug}${ROUTES.episodeById}${episodeSlug}`;
}

export function seriesAdminEditRoute(seriesId) {
  return `/admin/series/${seriesId}`;
}

export function episodeAdminEditRoute(episodeId) {
  return `/admin/episodes/${episodeId}`;
}

export function episodesForSeriesAdminRoute(seriesId) {
  return `/admin/series/${seriesId}/episodes`;
}

export function seriesRoute(seriesId) {
  return `${ROUTES.seriesById}${seriesId}`;
}

export function categoriesAdminEditRoute(categoryId) {
  return `/admin/categories/${categoryId}`;
}

export function sponsorsAdminEditRoute(sponsorId) {
  return `/admin/sponsors/${sponsorId}`;
}

export function usersAdminEditRoute(username) {
  return `/admin/users/${username}`;
}

export function categoryById(categoryId) {
  return `/categories/${categoryId}`;
}

export const ROUTES = {
  home: '/',
  login: '/login',
  episodes: '/episodes',
  episodeById: '/episodes/',
  series: '/series',
  seriesById: '/series/',
  categories: '/categories',
  about: '/about',
  contact: '/contact',
  collaborate: '/collaborate',
  cookiePolicy: '/cookie-policy',
  admin: '/admin', // Redirects to /admin/series
  series_admin: '/admin/series',
  episodes_admin: '/admin/episodes',
  categories_admin: '/admin/categories',
  sponsors_admin: '/admin/sponsors',
  users_admin: '/admin/users',
  home_admin: '/admin/home',
  episodes_page_admin: '/admin/episodes-page',
  series_page_admin: '/admin/series-page',
};

export default [
  {
    path: ROUTES.home,
    exact: true,
    componentPath: 'pages/homePage/HomePage',
    Component: universal(import('pages/homePage/HomePage'), options),
  },
  {
    path: ROUTES.episodes,
    exact: true,
    componentPath: 'pages/episodesPage/EpisodesPage',
    Component: universal(import('pages/episodesPage/EpisodesPage'), options),
  },
  {
    path: episodeRoute(':episodeId', ':seriesId'),
    exact: true,
    componentPath: 'pages/singleEpisodePage/SingleEpisodePage',
    Component: universal(
      import('pages/singleEpisodePage/SingleEpisodePage'),
      options
    ),
  },
  {
    path: ROUTES.series,
    exact: true,
    componentPath: 'pages/seriesPage/SeriesPage',
    Component: universal(import('pages/seriesPage/SeriesPage'), options),
  },
  {
    path: `${ROUTES.seriesById}:id`,
    exact: true,
    componentPath: 'pages/singleSeriesPage/SingleSeriesPage',
    Component: universal(
      import('pages/singleSeriesPage/SingleSeriesPage'),
      options
    ),
  },
  {
    path: categoryById(':id'),
    exact: true,
    componentPath: 'pages/singleCategoryPage/SingleCategoryPage',
    Component: universal(
      import('pages/singleCategoryPage/SingleCategoryPage'),
      options
    ),
  },
  {
    path: ROUTES.about,
    exact: true,
    componentPath: 'pages/aboutPage/AboutPage',
    Component: universal(import('pages/aboutPage/AboutPage'), options),
  },
  {
    path: ROUTES.contact,
    exact: true,
    componentPath: 'pages/aboutPage/AboutPage',
    Component: universal(import('pages/aboutPage/AboutPage'), options),
  },
  {
    path: ROUTES.collaborate,
    exact: true,
    componentPath: 'pages/collaboratePage/CollaboratePage',
    Component: universal(
      import('pages/collaboratePage/CollaboratePage'),
      options
    ),
  },
  {
    path: ROUTES.login,
    exact: true,
    componentPath: 'pages/loginPage/LoginPage',
    Component: universal(import('pages/loginPage/LoginPage'), options),
  },
  {
    path: ROUTES.admin,
    exact: true,
    componentPath: 'pages/adminPage/AdminPage',
    Component: universal(import('pages/adminPage/AdminPage'), options),
  },
  {
    path: ROUTES.series_admin,
    exact: true,
    componentPath: 'pages/adminPage/list/AdminListPage',
    Component: universal(import('pages/adminPage/list/AdminListPage'), options),
  },
  {
    path: episodesForSeriesAdminRoute(':entityId'),
    exact: true,
    componentPath: 'pages/adminPage/list/AdminListPage',
    Component: universal(import('pages/adminPage/list/AdminListPage'), options),
  },
  {
    path: seriesAdminEditRoute(':entityId'),
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.cookiePolicy,
    componentPath: 'pages/cookiePolicyPage/CookiePolicyPage',
    Component: universal(
      import('pages/cookiePolicyPage/CookiePolicyPage'),
      options
    ),
  },
  {
    path: episodeAdminEditRoute(':entityId'),
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.categories_admin,
    exact: true,
    componentPath: 'pages/adminPage/list/AdminListPage',
    Component: universal(import('pages/adminPage/list/AdminListPage'), options),
  },
  {
    path: categoriesAdminEditRoute(':entityId'),
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.sponsors_admin,
    exact: true,
    componentPath: 'pages/adminPage/list/AdminListPage',
    Component: universal(import('pages/adminPage/list/AdminListPage'), options),
  },
  {
    path: sponsorsAdminEditRoute(':entityId'),
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.users_admin,
    exact: true,
    componentPath: 'pages/adminPage/list/AdminListPage',
    Component: universal(import('pages/adminPage/list/AdminListPage'), options),
  },
  {
    path: usersAdminEditRoute(':entityId'),
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.home_admin,
    exact: true,
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.episodes_page_admin,
    exact: true,
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: ROUTES.series_page_admin,
    exact: true,
    componentPath: 'pages/adminPage/edit/AdminEntityEditPage',
    Component: universal(
      import('pages/adminPage/edit/AdminEntityEditPage'),
      options
    ),
  },
  {
    path: '*',
    componentPath: 'pages/notFoundPage/NotFoundPage',
    Component: universal(import('pages/notFoundPage/NotFoundPage'), options),
    status: 404,
  },
];
